import React from "react";
import { useSelector } from "react-redux";
import { useLoadPlatformDataAndCurrentUser } from "./features/frontend/frontendSlice";
import AppV1 from "./components-v1/AppV1";
import AppV2 from "./components-v2/AppV2";

const AppWrapper = () => {
  const { platformData } = useSelector(state => state.frontend);
  useLoadPlatformDataAndCurrentUser();

  if (!platformData.version) return null;
  if (platformData.version === "v1") {
    return <AppV1 />;
  } else {
    return <AppV2 />;
  }
};

export default AppWrapper;
